import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const addressField: CaptionRecord = {
  noAddressSelected: () => captionService.getString("22bc2b75-5ee2-40dd-bc1c-7916108c47b4", "No address selected"),
};
